import { CheckCircle2, XCircle } from "lucide-react";

export const STATUS_LABELS = { nuova: "Nuova", accettato: "Accettato", rifiutato: "Rifiutato" };
export const STATUS_STYLES = {
  nuova: "border-gold/50 bg-gold/10 text-gold-dark",
  accettato: "border-emerald-200 bg-emerald-50 text-emerald-700",
  rifiutato: "border-red-200 bg-red-50 text-red-700",
};

const StatusButton = ({ active, onClick, testid, title, activeCls, idleCls, icon: Icon, label }) => (
  <button
    onClick={onClick}
    disabled={active}
    data-testid={testid}
    title={title}
    className={`inline-flex items-center gap-1 border px-2 py-1 text-xs font-semibold uppercase tracking-wider transition-colors disabled:cursor-default ${active ? activeCls : idleCls}`}
  >
    <Icon className="h-3.5 w-3.5" /> {label}
  </button>
);

export const StatusControls = ({ app, onChange, size = "sm" }) => (
  <div className="inline-flex items-center gap-1">
    <StatusButton
      active={app.status === "accettato"}
      onClick={() => onChange(app.id, "accettato")}
      testid={`accept-application-${app.id}`}
      title="Accetta"
      icon={CheckCircle2}
      label={size === "lg" && "Accettato"}
      activeCls="border-emerald-500 bg-emerald-500 text-white"
      idleCls="border-emerald-200 text-emerald-700 hover:bg-emerald-50"
    />
    <StatusButton
      active={app.status === "rifiutato"}
      onClick={() => onChange(app.id, "rifiutato")}
      testid={`reject-application-${app.id}`}
      title="Rifiuta"
      icon={XCircle}
      label={size === "lg" && "Rifiutato"}
      activeCls="border-red-500 bg-red-500 text-white"
      idleCls="border-red-200 text-red-700 hover:bg-red-50"
    />
  </div>
);
